// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jw-0";
export var fileCarousel = "_jw-2";
export var removeFileButton = "_jw-1";